import { Anchor, type _Navigation } from ":setup/qrouter";
import { default as routes } from "../routes";
import { global } from ":shared/app";
import { LockedAnchor } from ":src/components/overlays";

export default function Schedule(props: _Navigation.SideNavJSXItemProps) {
  const $settings = global.store.hooks.platform.useSettings("evaluation");
  return (
    <Anchor
      class={`relative  ${props?.anchor?.class}`}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      events={{
        getShouldNavigate: () => !$settings().locked,
      }}
      triggers={{
        onBeforeNavigate: () => {
          if ($settings().locked) {
            global.store.actions.toast.pushToast({
              type: "error",
              message: "This page is locked by admin, you can't access it right now!",
            });
          }
        },
      }}
      components={{
        title: "Evaluation",
        idleIcon: <i class="i-ph:users-three" />,
        activeIcon: <i class="i-ph:users-three" />,
      }}
    >
      <LockedAnchor locked={$settings().locked} />
    </Anchor>
  );
}
